import addDays from 'date-fns/add_days';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import { Text, DatePicker } from 'components';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const DisconnectDialogDatePicker = ({ date, shiftDays, onChange }) => (
  <div className={cx('withBottomMargin')}>
    <Text tagType="p" className={cx('withBottomMargin')}>Дата отключения</Text>
    <DatePicker
      value={date}
      min={new Date()}
      max={addDays(new Date(), shiftDays)}
      onChange={onChange}
    />
  </div>
);

DisconnectDialogDatePicker.propTypes = {
  date: PropTypes.any,
  shiftDays: PropTypes.number,
  onChange: PropTypes.func,
};
